/**
 * Product image lightbox.
 * Opens a full-screen, paged Swiper of all product images with zoom.
 * Triggered by clicks on [data-lightbox-trigger] elements (the PDP images).
 */
(function () {
  'use strict';

  var overlay = document.querySelector('.product-lightbox');
  if (!overlay) return;

  var swiperEl = overlay.querySelector('.product-lightbox__swiper');
  var closeBtn = overlay.querySelector('.product-lightbox__close');
  if (!closeBtn) return;
  var lastTrigger = null;
  var swiper = null;
  var hideTimer = null;

  function buildSwiper(startIndex) {
    if (swiper) {
      swiper.update();
      swiper.slideTo(startIndex, 0);
      return;
    }
    swiper = new window.Swiper(swiperEl, {
      initialSlide: startIndex,
      slidesPerView: 1,
      threshold: 10,
      keyboard: { enabled: true },
      zoom: {
        maxRatio: 3,
        toggle: false,        // we drive desktop zoom on single click ourselves
        panOnMouseMove: true  // pan the zoomed image as the cursor moves (Mytheresa-style)
      },
      navigation: {
        prevEl: overlay.querySelector('.product-lightbox__arrow--prev'),
        nextEl: overlay.querySelector('.product-lightbox__arrow--next')
      },
      pagination: {
        el: overlay.querySelector('.product-lightbox__counter'),
        type: 'fraction'
      }
    });

    // Single-click toggles zoom on desktop (pinch handles mobile natively).
    swiperEl.querySelectorAll('.swiper-zoom-container').forEach(function (zc) {
      zc.addEventListener('click', function () {
        if (swiper.zoom.scale === 1) {
          swiper.zoom.in();
        } else {
          swiper.zoom.out();
        }
      });
    });
  }

  function open(index) {
    clearTimeout(hideTimer); // cancel any pending hide from a recent close
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lightbox-open');
    // build/refresh Swiper AFTER the overlay is displayed so it can measure slides
    buildSwiper(index || 0);
    // let the un-hide paint settle before transitioning opacity
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    });
    if (typeof window.trapFocus === 'function') {
      window.trapFocus(overlay, closeBtn);
    } else {
      closeBtn.focus();
    }
  }

  function close() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lightbox-open');
    if (typeof window.removeTrapFocus === 'function') {
      window.removeTrapFocus(lastTrigger);
    } else if (lastTrigger) {
      lastTrigger.focus();
    }
    // hide after the fade-out transition
    hideTimer = window.setTimeout(function () { overlay.hidden = true; }, 300);
  }

  // Delegated open triggers (PDP images)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lightbox-trigger]');
    if (!trigger) return;
    e.preventDefault();
    lastTrigger = trigger;
    var index = parseInt(trigger.getAttribute('data-media-index'), 10) || 0;
    open(index);
  });

  closeBtn.addEventListener('click', close);

  // Backdrop click closes (ignore clicks on the image/controls)
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay || e.target === swiperEl) close();
  });

  // ESC closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });
})();
